/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';
loadStyles([{"rawString":".root_df42c756{display:block}.resizeIsShort_df42c756{width:400px}.buttonGroup_df42c756{margin-bottom:40px}.buttonGroup_df42c756 button{margin-right:20px}.settingsGroup_df42c756{padding-top:20px}.itemCountDropdown_df42c756{width:180px}\n"}]);
export const root = "root_df42c756";
export const resizeIsShort = "resizeIsShort_df42c756";
export const buttonGroup = "buttonGroup_df42c756";
export const settingsGroup = "settingsGroup_df42c756";
export const itemCountDropdown = "itemCountDropdown_df42c756";